import { isMongoObjectId } from "./phone";

/** Strip client UUIDs before PATCH; keep only valid MongoDB _id values. */
export const sanitizeLinksForApi = (links = []) =>
  links.map(({ _id, description, is_admin, thumb, title, url, type }) => {
    const entry = {
      description: description ?? {},
      is_admin: is_admin ?? false,
      thumb: thumb ?? "",
      title: title ?? {},
      url: url ?? "",
      type: type ?? "url",
    };

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });
